var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLotus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "306px",
    height: "312px",
    viewBox: "0 0 306.0 312.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,0 C232.842712,0 300,67.1572875 300,150 C300,232.842712 232.842712,300 150,300 C67.1572875,300 0,232.842712 0,150 C0,67.1572875 67.1572875,0 150,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-10.0384798%",
    y: "-42.6168866%",
    filterUnits: "userSpaceOnUse",
    width: "114.340685%",
    height: "171.028144%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i2",
    result: "i3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0.940015831772162 0 0 0 0 0.9725469091146104 0 0 0 0 0.9762436224489796 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.463348,0 C204.06855,0 262.926695,9.02497791 262.926695,20.1578523 C262.926695,25.4011726 233.375575,24.9782811 211.976717,28.5638228 C206.208018,29.5304122 200.783133,30.7099471 195.338331,31.9445381 L193.976505,32.2542415 C177.170339,36.0858091 159.886652,40.3157047 131.463348,40.3157047 C105.778818,40.3157047 89.3616114,36.8420709 74.0958648,33.342276 L72.7316453,33.0288833 C72.2777875,32.9244568 71.8247399,32.8200988 71.3722866,32.7159009 L70.0164936,32.403879 L68.6629711,32.0933679 C67.9865616,31.9385817 67.3105178,31.7845684 66.6341111,31.6316373 L65.280598,31.3273101 C60.7658356,30.3183077 56.2133581,29.3665788 51.4072914,28.5638228 C47.9701441,27.9897169 44.3168573,27.5186546 40.6045866,27.1108353 L39.2100272,26.9607898 C38.9772421,26.9362504 38.7443034,26.9119386 38.5112493,26.8878447 L37.1118484,26.7458183 C18.676268,24.9081838 0,24.3091305 0,20.1578523 C0,18.5305011 8.12374268,16.0705425 16.8149334,13.74744 L17.7825725,13.4899299 L18.7525786,13.2338418 L19.7226482,12.9794711 L20.6904781,12.7271134 C26.8081113,11.1358459 32.6523933,9.68347205 35.590157,8.707824 C56.4188604,1.79049304 78.5120103,0 131.463348,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i5",
    x: "-66.1205071%",
    y: "-39.9748754%",
    filterUnits: "userSpaceOnUse",
    width: "194.457867%",
    height: "166.624792%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i6"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i6",
    result: "i7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09907326,0 C15.3821437,4.48065191 21.7965421,10.637396 24.3422683,18.4702323 C28.1608576,30.2194867 26.551131,41.2725752 19.2805252,43.634304 C12.0099194,45.9960328 5.09050061,37.7134878 1.2719113,25.9642333 C-1.27381491,18.131397 0.00190574538,9.4766526 5.09907326,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i9",
    x1: "9.41531634px",
    y1: "2.68616345px",
    x2: "17.0103033px",
    y2: "41.7563809px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i10",
    x: "-66.835778%",
    y: "-39.6002508%",
    filterUnits: "userSpaceOnUse",
    width: "195.479683%",
    height: "166.000418%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i11"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i11",
    result: "i12"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9972438,0 C25.1803591,9.35684895 27.2058226,18.0129229 25.0736343,25.9682218 C21.8753518,37.9011702 14.5037615,46.2945855 7.1194833,44.3165053 C-0.264794926,42.3384251 -1.55569909,31.6245245 1.64258339,19.6915761 C3.77477171,11.7362772 9.5596585,5.17241849 18.9972438,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i14",
    x1: "16.0403789px",
    y1: "2.41465201px",
    x2: "9.78857124px",
    y2: "42.6074908px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i15",
    x: "-51.9682868%",
    y: "-51.0703732%",
    filterUnits: "userSpaceOnUse",
    width: "174.24041%",
    height: "185.117289%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i16"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i16",
    result: "i17"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3364413,4.69643206 C14.9238523,-1.08794816 24.4380429,-1.52906128 37.8790129,3.3730927 C36.0710186,9.70175694 32.3733158,15.7582792 26.7859048,21.5426594 C18.4047883,30.2192297 8.05165296,33.8171146 2.55246754,28.5080386 C-2.94671788,23.1989626 0.955324761,13.3730024 9.3364413,4.69643206 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i19",
    x1: "31.0854483px",
    y1: "5.20563116px",
    x2: "6.53922408px",
    y2: "26.0038519px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i20",
    x: "-51.4407757%",
    y: "-51.8229414%",
    filterUnits: "userSpaceOnUse",
    width: "173.486822%",
    height: "186.371569%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i21"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i21",
    result: "i22"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.99142135 C14.4471574,-0.871377416 24.4135268,-2.36228339 29.8991084,3.51870344 C38.1274808,12.3401837 41.1795584,22.8646536 35.5885295,28.0769727 C29.9975006,33.2892918 20.3865887,28.8793919 12.1582164,20.0579116 C6.6726348,14.1769248 2.61989601,10.1547614 0,7.99142135 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i24",
    x1: "7.11724377px",
    y1: "4.9229163px",
    x2: "31.5676314px",
    y2: "25.6028991px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i25",
    x: "-48.3087258%",
    y: "-52.4739332%",
    filterUnits: "userSpaceOnUse",
    width: "169.012465%",
    height: "187.456555%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i26"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i26",
    result: "i27"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.7326631 C16.7998346,-0.00732420656 27.9425427,-2.93682445 33.4281243,2.94416237 C41.6564967,11.7656426 44.7085743,22.2901125 39.1175454,27.5024316 C33.5265165,32.7147508 23.9156046,28.3048508 15.6872323,19.4833706 C10.2016507,13.6023838 4.97257327,11.0188146 0,11.7326631 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i29",
    x1: "7.77079225px",
    y1: "4.82960471px",
    x2: "34.4663627px",
    y2: "25.1176081px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i30",
    x: "-47.5515617%",
    y: "-53.7149881%",
    filterUnits: "userSpaceOnUse",
    width: "167.930802%",
    height: "189.52498%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i31"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i31",
    result: "i32"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8834499,15.3732459 C38.0586445,13.9744819 32.5207963,15.8053564 26.269905,20.8658694 C16.8935682,28.4566389 6.76228479,31.4864007 1.95127681,25.5468956 C-2.85973117,19.6073904 1.62776029,9.60999702 11.0040971,2.01922749 C17.2549884,-3.04128553 27.8814393,1.41005394 42.8834499,15.3732459 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i34",
    x1: "36.8251691px",
    y1: "22.6715003px",
    x2: "5.73614567px",
    y2: "5.83430456px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i35",
    x: "-37.0030715%",
    y: "-49.3506255%",
    filterUnits: "userSpaceOnUse",
    width: "152.861531%",
    height: "182.251043%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i36"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i36",
    result: "i37"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,28.4410725 C17.1347745,6.10947118 30.6167407,-3.07124376 40.4458986,0.898927701 C55.1896354,6.85418489 63.5117268,28.0602239 57.915167,29.8710279 C52.3186072,31.681832 43.7414084,35.3084698 28.9976716,29.3532126 C19.1685137,25.3830412 9.50262316,25.0789945 0,28.4410725 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i39",
    x1: "4.29717479px",
    y1: "10.6732555px",
    x2: "55.9069846px",
    y2: "22.076504px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i40",
    x: "-37.0321272%",
    y: "-48.3918418%",
    filterUnits: "userSpaceOnUse",
    width: "152.903039%",
    height: "180.65307%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i41"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i41",
    result: "i42"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6100233,24.6269725 C49.8079293,22.2763402 40.2267796,23.5888108 30.8665742,28.5643842 C16.8262661,36.0277443 7.91686551,33.3172943 2.16163285,32.1012527 C-3.59359982,30.8852112 2.4656724,8.92567922 16.5059805,1.46231912 C25.8661858,-3.51325428 40.2342001,4.20829686 59.6100233,24.6269725 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i44",
    x1: "54.0999325px",
    y1: "24.0778297px",
    x2: "5.00134608px",
    y2: "9.36485551px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i45",
    x: "-56.1903638%",
    y: "-54.2008219%",
    filterUnits: "userSpaceOnUse",
    width: "180.271948%",
    height: "190.334703%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i46"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i46",
    result: "i47"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8306081,0 C30.5708216,16.8805611 23.2990579,23.940642 20.3938641,26.8295771 L20.1029417,27.1201251 C19.7377847,27.4874011 19.4655508,27.7755169 19.3098151,28.0003682 C18.0120175,29.8741292 5.42429253,21.9681817 2.28269659,14.8991308 C0.0975247314,9.98217419 -4.25696946,-1.78889188 11.0978067,2.41464023 C26.4525828,6.61817234 8.87740033,1.7866156 33.8306081,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i49",
    x1: "16.9153041px",
    y1: "1.08607939px",
    x2: "16.9153041px",
    y2: "27.4670436px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i50",
    x: "-52.3807558%",
    y: "-28.7487736%",
    filterUnits: "userSpaceOnUse",
    width: "174.829651%",
    height: "147.914623%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i51"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i51",
    result: "i52"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1094387,0 C25.5346279,8.51172458 33.9208564,18.8037887 36.2681241,30.8761922 C39.7890256,48.9847976 35.3912023,65.0740055 24.1853396,67.2516198 C12.979477,69.4292341 4.2317064,55.8945849 0.710804875,37.7859795 C-1.63646281,25.7135759 1.82974846,13.1182494 11.1094387,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i54",
    x1: "15.4284896px",
    y1: "3.16392697px",
    x2: "22.0953363px",
    y2: "64.9581885px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i55",
    x: "-53.019905%",
    y: "-28.5390348%",
    filterUnits: "userSpaceOnUse",
    width: "175.742721%",
    height: "147.565058%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i56"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i56",
    result: "i57"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1590156,0 C33.247212,12.5515631 38.0417125,24.9306891 36.542517,37.1373781 C34.2937239,55.4474115 25.1379717,69.3905202 13.8074624,67.9996821 C2.47695323,66.608844 -1.65911125,51.0341436 0.589681875,32.7241101 C2.08887729,20.5174211 9.27865519,9.60938441 22.1590156,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i59",
    x1: "20.4759183px",
    y1: "2.84948213px",
    x2: "16.2910745px",
    y2: "65.8991656px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i60",
    x: "-42.1552137%",
    y: "-28.7997866%",
    filterUnits: "userSpaceOnUse",
    width: "160.221734%",
    height: "147.999644%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i61"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i61",
    result: "i62"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8013327,0 C51.6991863,17.7812346 52.5301236,32.5343631 46.2941446,44.2593853 C36.9401761,61.8469187 21.3835658,71.8658673 9.06262587,65.3164661 C-3.25831408,58.7670648 -2.15539455,41.0650156 7.19857396,23.4774822 C13.434553,11.75246 25.6354726,3.92663256 43.8013327,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i64",
    x1: "36.1371692px",
    y1: "6.22405702px",
    x2: "14.0552273px",
    y2: "61.6845588px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i65",
    x: "-41.4178884%",
    y: "-29.5459748%",
    filterUnits: "userSpaceOnUse",
    width: "159.168412%",
    height: "149.243291%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i66"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i66",
    result: "i67"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80636851,0 C11.7264196,4.835772 17.8712861,8.34048898 22.2409678,10.5141509 C24.2439165,11.5105011 26.6167297,12.2468196 29.0551256,12.940782 L29.9179636,13.1843056 L30.7832751,13.4264384 C35.9766189,14.8793165 41.142998,16.371934 43.3928191,19.9714338 C53.9511756,36.8638002 54.8518644,55.3420774 43.0179235,62.7347593 C31.1839825,70.1274411 16.4009014,60.3215166 5.84254489,43.4291503 C-1.19635942,32.1675727 -1.87508489,17.6911893 3.80636851,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i69",
    x1: "13.1791474px",
    y1: "7.08032396px",
    x2: "38.6888157px",
    y2: "58.6837137px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i70",
    x: "-46.4510776%",
    y: "-26.4930974%",
    filterUnits: "userSpaceOnUse",
    width: "166.358682%",
    height: "144.155162%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "i71"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "i71",
    result: "i72"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2933478,0 C36.6167642,12.4025166 44.2784724,25.2434794 44.2784724,38.5228884 C44.2784724,58.442002 35.2476753,74.5896341 21.2933478,74.5896341 C7.33902017,74.5896341 0,58.442002 0,38.5228884 C0,25.2434794 7.09778259,12.4025166 21.2933478,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i74",
    x1: "22.1392362px",
    y1: "2.8646011px",
    x2: "22.1392362px",
    y2: "72.4460146px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 300,0 300,300 0,300 0,0",
    stroke: "none",
    fill: "#FFFFC2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.0 201.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5033403495927473 0.08161073825499443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 51.23087248322143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.463348,40.3157047 C169.873219,40.3157047 187.940472,32.5912788 211.976717,28.5638228 C233.375575,24.9782811 262.926695,25.4011726 262.926695,20.1578523 C262.926695,9.02497791 204.06855,0 131.463348,0 C78.5120103,0 56.4188604,1.79049304 35.590157,8.707824 C27.8591998,11.2753189 0,17.144239 0,20.1578523 C0,25.4126348 29.925121,24.9756614 51.4072914,28.5638228 C75.4376249,32.5776031 93.1282294,40.3157047 131.463348,40.3157047 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i1)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 262.926695,0 262.926695,40.3157047 0,40.3157047 0,0",
    stroke: "none",
    fill: "#EADFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.78694975748147 3.552713678800501e-14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.55511980718148 6.351578219780642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2805252,43.634304 C26.551131,41.2725752 28.1608576,30.2194867 24.3422683,18.4702323 C21.7965421,10.637396 15.3821437,4.48065191 5.09907326,0 C0.00190574538,9.4766526 -1.27381491,18.131397 1.2719113,25.9642333 C5.09050061,37.7134878 12.0099194,45.9960328 19.2805252,43.634304 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i5)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.7533531e-14,0 26.3469227,0 26.3469227,44.0377106 -2.7533531e-14,44.0377106 -2.7533531e-14,0",
    stroke: "none",
    fill: "url(#i9)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.09039519225149 3.993187868019824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1194833,44.3165053 C14.5037615,46.2945855 21.8753518,37.9011702 25.0736343,25.9682218 C27.2058226,18.0129229 25.1803591,9.35684895 18.9972438,0 C9.5596585,5.17241849 3.77477171,11.7362772 1.64258339,19.6915761 C-1.55569909,31.6245245 -0.264794926,42.3384251 7.1194833,44.3165053 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i10)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.63993297e-14,0 25.8937295,0 25.8937295,44.6056767 5.63993297e-14,44.6056767 5.63993297e-14,0",
    stroke: "none",
    fill: "url(#i14)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.68835631993244 19.711872025807768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55246754,28.5080386 C8.05165296,33.8171146 18.4047883,30.2192297 26.7859048,21.5426594 C32.3733158,15.7582792 36.0710186,9.70175694 37.8790129,3.3730927 C24.4380429,-1.52906128 14.9238523,-1.08794816 9.3364413,4.69643206 C0.955324761,13.3730024 -2.94671788,23.1989626 2.55246754,28.5080386 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i15)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i18)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.84217094e-14,0 37.8790129,0 37.8790129,30.9939781 -2.84217094e-14,30.9939781 -2.84217094e-14,0",
    stroke: "none",
    fill: "url(#i19)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.1468278442066 23.05526572798627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5885295,28.0769727 C41.1795584,22.8646536 38.1274808,12.3401837 29.8991084,3.51870344 C24.4135268,-2.36228339 14.4471574,-0.871377416 0,7.99142135 C2.61989601,10.1547614 6.6726348,14.1769248 12.1582164,20.0579116 C20.3865887,28.8793919 29.9975006,33.2892918 35.5885295,28.0769727 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i20)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i23)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,5.32907052e-15 38.4315276,5.32907052e-15 38.4315276,30.3115357 0,30.3115357 0,5.32907052e-15",
    stroke: "none",
    fill: "url(#i24)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5091535847423643 37.077828533463304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1175454,27.5024316 C44.7085743,22.2901125 41.6564967,11.7656426 33.4281243,2.94416237 C27.9425427,-2.93682445 16.7998346,-0.00732420656 0,11.7326631 C4.97257327,11.0188146 10.2016507,13.6023838 15.6872323,19.4833706 C23.9156046,28.3048508 33.5265165,32.7147508 39.1175454,27.5024316 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i25)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-4.4408921e-16 41.9605435,-4.4408921e-16 41.9605435,29.7369946 0,29.7369946 0,-4.4408921e-16",
    stroke: "none",
    fill: "url(#i29)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.4903076364208 29.693721207280337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95127681,25.5468956 C-2.85973117,19.6073904 1.62776029,9.60999702 11.0040971,2.01922749 C17.2549884,-3.04128553 27.8814393,1.41005394 42.8834499,15.3732459 C38.0586445,13.9744819 32.5207963,15.8053564 26.269905,20.8658694 C16.8935682,28.4566389 6.76228479,31.4864007 1.95127681,25.5468956 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i30)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i33)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.28546088e-14,3.55271368e-15 42.8834499,3.55271368e-15 42.8834499,28.6802668 4.28546088e-14,28.6802668 4.28546088e-14,3.55271368e-15",
    stroke: "none",
    fill: "url(#i34)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.3897497841891777 44.653058477885494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.915167,29.8710279 C63.5117268,28.0602239 55.1896354,6.85418489 40.4458986,0.898927701 C30.6167407,-3.07124376 17.1347745,6.10947118 0,28.4410725 C9.50262316,25.0789945 19.1685137,25.3830412 28.9976716,29.3532126 C43.7414084,35.3084698 52.3186072,31.681832 57.915167,29.8710279 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i35)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i38)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,7.77156117e-15 59.6693942,7.77156117e-15 59.6693942,32.6316024 0,32.6316024 0,7.77156117e-15",
    stroke: "none",
    fill: "url(#i39)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.81753733584452 42.9518344848988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16163285,32.1012527 C-3.59359982,30.8852112 2.4656724,8.92567922 16.5059805,1.46231912 C25.8661858,-3.51325428 40.2342001,4.20829686 59.6100233,24.6269725 C49.8079293,22.2763402 40.2267796,23.5888108 30.8665742,28.5643842 C16.8262661,36.0277443 7.91686551,33.3172943 2.16163285,32.1012527 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i40)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i43)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-4.4408921e-16,1.44328993e-14 59.6100233,1.44328993e-14 59.6100233,33.5951366 -4.4408921e-16,33.5951366 -4.4408921e-16,1.44328993e-14",
    stroke: "none",
    fill: "url(#i44)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.88245053115344 70.97008089686508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0978067,2.41464023 C26.4525828,6.61817234 8.87740033,1.7866156 33.8306081,0 C29.9955651,19.8594836 20.6076126,26.1266072 19.3098151,28.0003682 C18.0120175,29.8741292 5.42429253,21.9681817 2.28269659,14.8991308 C0.0975247314,9.98217419 -4.25696946,-1.78889188 11.0978067,2.41464023 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i45)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i48)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.37667655e-14,0 33.8306081,0 33.8306081,28.2797714 1.37667655e-14,28.2797714 1.37667655e-14,0",
    stroke: "none",
    fill: "url(#i49)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.61289593851285 1.5139383475705372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1853396,67.2516198 C35.3912023,65.0740055 39.7890256,48.9847976 36.2681241,30.8761922 C33.9208564,18.8037887 25.5346279,8.51172458 11.1094387,0 C1.82974846,13.1182494 -1.63646281,25.7135759 0.710804875,37.7859795 C4.2317064,55.8945849 12.979477,69.4292341 24.1853396,67.2516198 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i50)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i53)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-5.68434189e-14,0 37.454746,0 37.454746,67.481822 -5.68434189e-14,67.481822 -5.68434189e-14,0",
    stroke: "none",
    fill: "url(#i54)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.93101021586693 0.707363206954291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8074624,67.9996821 C25.1379717,69.3905202 34.2937239,55.4474115 36.542517,37.1373781 C38.0417125,24.9306891 33.247212,12.5515631 22.1590156,0 C9.27865519,9.60938441 2.08887729,20.5174211 0.589681875,32.7241101 C-1.65911125,51.0341436 2.47695323,66.608844 13.8074624,67.9996821 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i55)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i58)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.85327317e-14,0 36.8103549,0 36.8103549,68.0953459 -2.85327317e-14,68.0953459 -2.85327317e-14,0",
    stroke: "none",
    fill: "url(#i59)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.11953056691613 9.059356213133164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.06262587,65.3164661 C21.3835658,71.8658673 36.9401761,61.8469187 46.2941446,44.2593853 C52.5301236,32.5343631 51.6991863,17.7812346 43.8013327,0 C25.6354726,3.92663256 13.434553,11.75246 7.19857396,23.4774822 C-2.15539455,41.0650156 -3.25831408,58.7670648 9.06262587,65.3164661 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i60)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i63)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.77635684e-15,0 50.4212029,0 50.4212029,67.3339509 1.77635684e-15,67.3339509 1.77635684e-15,0",
    stroke: "none",
    fill: "url(#i64)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.63142125119617 12.207693424674211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0179235,62.7347593 C54.8518644,55.3420774 53.9511756,36.8638002 43.3928191,19.9714338 C39.8306024,14.2722258 28.9567368,13.8548545 22.2409678,10.5141509 C17.8712861,8.34048898 11.7264196,4.835772 3.80636851,0 C-1.87508489,17.6911893 -1.19635942,32.1675727 5.84254489,43.4291503 C16.4009014,60.3215166 31.1839825,70.1274411 43.0179235,62.7347593 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i65)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i68)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.19744231e-14,0 51.6036396,0 51.6036396,65.229339 3.19744231e-14,65.229339 3.19744231e-14,0",
    stroke: "none",
    fill: "url(#i69)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.85769112125837 1.5161955664665143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2933478,74.5896341 C35.2476753,74.5896341 44.2784724,58.442002 44.2784724,38.5228884 C44.2784724,25.2434794 36.6167642,12.4025166 21.2933478,0 C7.09778259,12.4025166 0,25.2434794 0,38.5228884 C0,58.442002 7.33902017,74.5896341 21.2933478,74.5896341 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i70)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i73)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 44.2784724,0 44.2784724,74.5896341 0,74.5896341 0,0",
    stroke: "none",
    fill: "url(#i74)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotus);
export default __webpack_public_path__ + "static/media/lotus.528cecb084cdf9b337ad00d5a8150102.svg";
export { ForwardRef as ReactComponent };